// apiConfig.ts
const screenSet = process.env.REACT_APP_SCREEN_SET;
let API_BASE_URL;

switch (screenSet) {
    case 'client':
        API_BASE_URL = 'https://crm.ateshstudio.ru/api/v1/portal-access/651a7418c3e4d46f2';
        break;
    case 'admin':
        API_BASE_URL = 'https://crm.ateshstudio.ru/api/v1';
        break;
    default:
        API_BASE_URL = 'https://crm.ateshstudio.ru/api/v1';
        break;
}


const apiConfig = {
    STUDENT: `${API_BASE_URL}/Student`,
    PAYMENT: `${API_BASE_URL}/Payment`,
    PAYMENTREQUEST: `${API_BASE_URL}/PayRequest`,

    PAYMENTDETAIL: `${API_BASE_URL}/Payment`,
    STUDENTDETAIL:`${API_BASE_URL}/Student`,
    ATTENDANCECLIENT:`${API_BASE_URL}/Attendances/student`,
    ATTENDANCES:`${API_BASE_URL}/Attendance`,
    LESSONS:`${API_BASE_URL}/Lesson`,

    ATTENDANCECLIENTSETCOMMENT:`${API_BASE_URL}/Attendances/commentclient`,
    CASES:`${API_BASE_URL}/Case`,
    CHANGEPASSWORD:`${API_BASE_URL}/UserSecurity/password`,
    SETUSERAGREEMENT:`${API_BASE_URL}/UserAgreement`,
    USERDETAIL: `${API_BASE_URL}/User`,
    SHEDULE:`${API_BASE_URL}/SheduleStudent/student`,
    USER: `${API_BASE_URL}/App/user`,
    PASSWORD_RESET: `${API_BASE_URL}/User/passwordChangeRequest`,
    GROUP: `${API_BASE_URL}/Group`,
    FACILITY: `${API_BASE_URL}/Facility`,
    ANNOUNCEMENT: `${API_BASE_URL}/Announcement`,
    DEVICE_TOKEN: `${API_BASE_URL}/UserDeviceToken`,
    ANNOUNCEMENT_ATTACHMENT: `${API_BASE_URL}/Announcement/attachment`,
    TRIP: `${API_BASE_URL}/Trip`,
};

export default apiConfig;
